// extracted by mini-css-extract-plugin
module.exports = {"container":"Navigation-module--container--2k_pQ","wrapper":"Navigation-module--wrapper--3jd7V","logo":"Navigation-module--logo--2R2ij","links":"Navigation-module--links--2S3An"};